import { Component, EventEmitter,  Output, inject, signal } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { BookService } from 'src/app/services/book.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IRecommendationsEntry } from 'src/app/_models/recommendations.model';
import { LogService } from 'src/app/services';

@Component({
    selector: 'kbm-recommendation-row',
    standalone: true,
    imports: [
        MatSelectModule,
        MatInputModule,
        MatAutocompleteModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
    ],
    templateUrl: './recommendation-row.component.html',
    styleUrls: ['./recommendation-row.component.scss']
})
export class RecommendationRowComponent {


  @Output()
  addNewRecommendationEvent = new EventEmitter<IRecommendationsEntry>();

  newRecommendation = signal<IRecommendationsEntry>({ "from": "", "to": "" });

  bookService = inject(BookService);
  logService = inject(LogService);

  allUsers: string[] = [];

  userNameControl = new FormControl('');
  filteredUsers!: Observable<string[]>;

  ngOnInit() {
    this.loadUserNames();
  }
  
  onUserSelectChange(event: any, fieldName: string) {
    this.newRecommendation.update((recommendation) => ({
      ...recommendation,
      [fieldName]: event?.value
    }))
  }


  addRecommendation() {
    this.addNewRecommendationEvent.emit(this.newRecommendation());
    this.newRecommendation.set({
      "from": "",
      "to": ""
    })

  }

  clearRecommendation() {
    this.newRecommendation.update((sr) =>
    ({
      "from": "",
      "to": ""
    }));
  //  this.nameControl.setValue('');
  }

  async loadUserNames() {
    try {
      const users = await this.bookService.getUsers();
      this.allUsers =  users.map(u => u.username);
    }
    catch (err) {
      this.logService.error(JSON.stringify(err));
      console.log(err);
    }
  }


}
